var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDecisionEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 18.334H13.3333",
    stroke: "#155DFC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 15.834H15.8333",
    stroke: "#155DFC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 13.334H18.3333",
    stroke: "#155DFC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5C7.23858 5 5 7.23858 5 10C5 11.2681 5.47205 12.4259 6.25 13.3073H13.75C14.528 12.4259 15 11.2681 15 10C15 7.23858 12.7614 5 10 5Z",
    stroke: "#155DFC",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.33398L10.5303 7.80365C10.2374 7.51076 9.76256 7.51076 9.46967 7.80365L10 8.33398ZM11.1363 10.531C11.4292 10.8239 11.9041 10.8239 12.197 10.531C12.4899 10.2381 12.4899 9.76321 12.197 9.47032L11.1363 10.531ZM7.803 9.47032C7.51011 9.76321 7.51011 10.2381 7.803 10.531C8.0959 10.8239 8.57077 10.8239 8.86366 10.531L7.803 9.47032ZM10 13.334H10.75V8.33398H10H9.25V13.334H10ZM10 8.33398L9.46967 8.86431L11.1363 10.531L11.6667 10.0007L12.197 9.47032L10.5303 7.80365L10 8.33398ZM10 8.33398L9.46967 7.80365L7.803 9.47032L8.33333 10.0007L8.86366 10.531L10.5303 8.86431L10 8.33398Z",
    fill: "#155DFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66602V2.49935",
    stroke: "#155DFC",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10L17.5 10",
    stroke: "#155DFC",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10L1.66667 10",
    stroke: "#155DFC",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8923 4.10742L15.565 4.43479",
    stroke: "#155DFC",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43481 4.43555L4.10745 4.10818",
    stroke: "#155DFC",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDecisionEngine);
export default __webpack_public_path__ + "static/media/Active Decision Engine.5878a8cff5c17592a3fcc27e844a8780.svg";
export { ForwardRef as ReactComponent };